// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"d981ee76","72":"962679ac","238":"2aa6b841","372":"67852120","573":"f242ac6f","634":"6289b015","776":"824d8c19"}[chunkId] + ".chunk.css";
};